import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AccountMessagesService as CoreLabsAccountMessagesService } from '@corelabs/angular/account';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';

@Injectable()
export class AccountMessagesService {
    private readonly accountMessagesService = inject(CoreLabsAccountMessagesService);
    private readonly messageService = inject(MessageService);
    private readonly translateService = inject(TranslateService);

    constructor() {
        this.accountMessagesService.messages$
            .pipe(
                tap((message) => {
                    const translatedMessage = this.translateService.instant(`cl.account.${message.key}`);
                    this.messageService.add(translatedMessage, message.type);
                }),
                takeUntilDestroyed(),
            )
            .subscribe();
    }
}
